/* eslint-disable @typescript-eslint/prefer-for-of */
/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { EntityDefinitions } from "../InternalInterfaces";
import { extractDisplayNames, isMaxUrlLengthReached, removeCommaFromEnd } from "../MetadataEntityCRMUtils";
var MetadataEntityPairTraversal = /** @class */ (function () {
    function MetadataEntityPairTraversal(commonDataService, retrievedEntityPairs, retrievedEntityDisplayNames) {
        if (retrievedEntityPairs === void 0) { retrievedEntityPairs = {}; }
        if (retrievedEntityDisplayNames === void 0) { retrievedEntityDisplayNames = {}; }
        this.commonDataService = commonDataService;
        this.retrievedEntityPairs = retrievedEntityPairs;
        this.retrievedEntityDisplayNames = retrievedEntityDisplayNames;
        this.MaxAllowedLeavesForTraversal = 500000;
        this.EntityPairsUrlLengthWithoutEntities = 450;
        this.DisplayNamesUrlLengthWithoutEntities = 200;
    }
    MetadataEntityPairTraversal.prototype.traverseHop = function (entityPairsRequest, primaryEntitiesAsNodes, foundEntityPairs, cancellationToken) {
        if (primaryEntitiesAsNodes === void 0) { primaryEntitiesAsNodes = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var nextEntityNodesForTraversal, foundEntitiesPaths, metadataEntityPairsResult, i, relationshipNode, pathToNode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nextEntityNodesForTraversal = {};
                        foundEntitiesPaths = [];
                        this.enrichIncludedEntitiesIfNeeded(entityPairsRequest.primaryEntityLogicalName, entityPairsRequest.relatedEntityLogicalName, entityPairsRequest.entitiesToInclude);
                        return [4 /*yield*/, this.getMetadataEntityPairs(primaryEntitiesAsNodes, entityPairsRequest.includeToOneRelationship, entityPairsRequest.includeToManyRelationship, entityPairsRequest.languageCode, entityPairsRequest.entitiesToInclude, entityPairsRequest.entitiesToExclude)];
                    case 1:
                        metadataEntityPairsResult = _a.sent();
                        for (i = 0; i < metadataEntityPairsResult.entityPairNodes.length; i++) {
                            if (cancellationToken === null || cancellationToken === void 0 ? void 0 : cancellationToken.isCancelled()) {
                                break;
                            }
                            relationshipNode = metadataEntityPairsResult.entityPairNodes[i];
                            if (relationshipNode.pathToNode.entities.includes(relationshipNode.logicalName) && entityPairsRequest.primaryEntityLogicalName !== entityPairsRequest.relatedEntityLogicalName) {
                                continue; // Already traversed entities are skipped
                            }
                            pathToNode = __spreadArray(__spreadArray([], __read(relationshipNode.pathToNode.entities), false), [relationshipNode.logicalName], false);
                            if (relationshipNode.logicalName === entityPairsRequest.relatedEntityLogicalName) {
                                foundEntitiesPaths.push({ entities: pathToNode });
                            }
                            else {
                                if (!nextEntityNodesForTraversal[relationshipNode.logicalName]) {
                                    nextEntityNodesForTraversal[relationshipNode.logicalName] = [];
                                }
                                nextEntityNodesForTraversal[relationshipNode.logicalName].push(this.createEntityPairAsNode(relationshipNode.logicalName, pathToNode));
                            }
                        }
                        return [4 /*yield*/, this.returnResult(foundEntitiesPaths, entityPairsRequest.languageCode, this.retrievedEntityDisplayNames, foundEntityPairs)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, { entityNodesForTraversal: nextEntityNodesForTraversal, isMaxTraversalExceeded: metadataEntityPairsResult.isMaxTraversalExceeded }];
                }
            });
        });
    };
    MetadataEntityPairTraversal.prototype.returnResult = function (entityPairs, languageCode, retrievedEntityDisplayNames, foundEntityPairs) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.populateEntityDisplayNames(entityPairs, languageCode)];
                    case 1:
                        _a.sent();
                        entityPairs.forEach(function (x) {
                            var entityPairs = x.entities.map(function (logicalName) { return _this.createEntityPair(logicalName, retrievedEntityDisplayNames[logicalName]); });
                            foundEntityPairs(entityPairs);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    MetadataEntityPairTraversal.prototype.populateEntityDisplayNames = function (foundEntitiesPaths, languageCode) {
        return __awaiter(this, void 0, void 0, function () {
            var entitiesToRetrieve, filters, promises, i, responses, responses_1, responses_1_1, response;
            var e_1, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        entitiesToRetrieve = new Set(foundEntitiesPaths.flatMap(function (x) { return x.entities; }).filter(function (entityLogicalName) { return !_this.retrievedEntityDisplayNames[entityLogicalName]; }));
                        if (entitiesToRetrieve.size === 0) {
                            return [2 /*return*/];
                        }
                        filters = this.buildDisplayNamesFiter(entitiesToRetrieve);
                        promises = [];
                        for (i = 0; i < filters.length; i++) {
                            promises.push(this.commonDataService.getRecords(EntityDefinitions, filters[i]));
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        responses = _b.sent();
                        try {
                            for (responses_1 = __values(responses), responses_1_1 = responses_1.next(); !responses_1_1.done; responses_1_1 = responses_1.next()) {
                                response = responses_1_1.value;
                                this.extractDisplayNames(response, languageCode);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (responses_1_1 && !responses_1_1.done && (_a = responses_1.return)) _a.call(responses_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MetadataEntityPairTraversal.prototype.getMetadataEntityPairs = function (primaryEntitiesAsNodes, includeToOneRelationship, includeToManyRelationship, languageCode, entitiesToInclude, entitiesToExclude) {
        if (primaryEntitiesAsNodes === void 0) { primaryEntitiesAsNodes = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var entityLogicalNames, entitiesToRetrieve, isMaxTraversalExceeded, filters, promises, i, responses, responses_2, responses_2_1, response, entityPairNodes;
            var e_2, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        entityLogicalNames = this.filterEntitiesToBeRetrieved(Object.keys(primaryEntitiesAsNodes), entitiesToInclude, entitiesToExclude);
                        entitiesToRetrieve = new Set(entityLogicalNames.filter(function (entityLogicalName) { return !_this.retrievedEntityPairs[entityLogicalName]; }));
                        isMaxTraversalExceeded = false;
                        if (!(entitiesToRetrieve.size > 0)) return [3 /*break*/, 2];
                        filters = this.buildEntityPairsFiter(entitiesToRetrieve, includeToOneRelationship, includeToManyRelationship);
                        promises = [];
                        for (i = 0; i < filters.length; i++) {
                            promises.push(this.commonDataService.getRecords(EntityDefinitions, filters[i]));
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        responses = _b.sent();
                        try {
                            for (responses_2 = __values(responses), responses_2_1 = responses_2.next(); !responses_2_1.done; responses_2_1 = responses_2.next()) {
                                response = responses_2_1.value;
                                this.extractCRMEntityDefinition(response, entitiesToInclude, entitiesToExclude, languageCode);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (responses_2_1 && !responses_2_1.done && (_a = responses_2.return)) _a.call(responses_2);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        _b.label = 2;
                    case 2:
                        entityPairNodes = [];
                        entityLogicalNames.forEach(function (primaryLogicalName) {
                            var e_3, _a;
                            if (entityPairNodes.length > _this.MaxAllowedLeavesForTraversal) {
                                isMaxTraversalExceeded = true;
                                return;
                            }
                            var entity = _this.retrievedEntityPairs[primaryLogicalName];
                            if (entity) {
                                var neighbours = entity.neighbours.flatMap(function (relatedEntity) { return primaryEntitiesAsNodes[primaryLogicalName].map(function (pathToPrimary) {
                                    return _this.createEntityPairAsNode(relatedEntity, pathToPrimary.pathToNode.entities);
                                }); });
                                var set = new Set();
                                try {
                                    for (var neighbours_1 = __values(neighbours), neighbours_1_1 = neighbours_1.next(); !neighbours_1_1.done; neighbours_1_1 = neighbours_1.next()) {
                                        var element = neighbours_1_1.value;
                                        var hash = __spreadArray([element.logicalName], __read(element.pathToNode.entities), false).join();
                                        if (!set.has(hash)) {
                                            set.add(hash);
                                            entityPairNodes.push(element);
                                        }
                                    }
                                }
                                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                finally {
                                    try {
                                        if (neighbours_1_1 && !neighbours_1_1.done && (_a = neighbours_1.return)) _a.call(neighbours_1);
                                    }
                                    finally { if (e_3) throw e_3.error; }
                                }
                            }
                        });
                        return [2 /*return*/, { entityPairNodes: entityPairNodes, isMaxTraversalExceeded: isMaxTraversalExceeded }];
                }
            });
        });
    };
    MetadataEntityPairTraversal.prototype.enrichIncludedEntitiesIfNeeded = function (primaryEntityLogicalName, relatedEntityLogicalName, entitiesToInclude) {
        if (entitiesToInclude.length === 0) {
            return;
        }
        if (!entitiesToInclude.includes(primaryEntityLogicalName)) {
            entitiesToInclude.push(primaryEntityLogicalName);
        }
        if (!entitiesToInclude.includes(relatedEntityLogicalName)) {
            entitiesToInclude.push(relatedEntityLogicalName);
        }
    };
    MetadataEntityPairTraversal.prototype.filterEntitiesToBeRetrieved = function (entityLogicalNames, entitiesToInclude, entitiesToExclude) {
        if (entitiesToInclude.length === 0 && entitiesToExclude.length === 0) {
            return entityLogicalNames;
        }
        else if (entitiesToInclude.length === 0 && entitiesToExclude.length !== 0) {
            return entityLogicalNames.filter(function (logicalName) { return !entitiesToExclude.includes(logicalName); });
        }
        else {
            return entitiesToInclude.filter(function (logicalName) { return entityLogicalNames.includes(logicalName); });
        }
    };
    MetadataEntityPairTraversal.prototype.extractCRMEntityDefinition = function (metadataCRMRelationships, entitiesToInclude, entitiesToExclude, languageCode) {
        var _this = this;
        metadataCRMRelationships.forEach(function (record) {
            var _a;
            if (!_this.retrievedEntityPairs[record.LogicalName]) {
                _this.retrievedEntityPairs[record.LogicalName] = _this.createEntityPairWithNeighbours(record.LogicalName, _this.extracRelationshipsFromEntity(record, entitiesToInclude, entitiesToExclude, languageCode));
            }
            else {
                (_a = _this.retrievedEntityPairs[record.LogicalName].neighbours).push.apply(_a, __spreadArray([], __read(_this.extracRelationshipsFromEntity(record, entitiesToInclude, entitiesToExclude, languageCode)), false));
            }
        });
    };
    MetadataEntityPairTraversal.prototype.extracRelationshipsFromEntity = function (entity, entitiesToInclude, entitiesToExclude, languageCode) {
        var _a, _b, _c, _d;
        var retValue = new Set();
        this.extractDisplayNames([entity], languageCode);
        (_a = entity.Attributes) === null || _a === void 0 ? void 0 : _a.forEach(function (x) {
            x.Targets.forEach(function (target) {
                if (target !== entity.LogicalName) {
                    retValue.add(target);
                }
            });
        });
        (_b = entity.OneToManyRelationships) === null || _b === void 0 ? void 0 : _b.filter(function (x) { return x.ReferencingEntity !== entity.LogicalName; }).forEach(function (x) { return retValue.add(x.ReferencingEntity); });
        (_c = entity.ManyToOneRelationships) === null || _c === void 0 ? void 0 : _c.filter(function (x) { return x.ReferencedEntity !== entity.LogicalName; }).forEach(function (x) { return retValue.add(x.ReferencedEntity); });
        (_d = entity.ManyToManyRelationships) === null || _d === void 0 ? void 0 : _d.filter(function (x) { return x.Entity1LogicalName !== x.Entity2LogicalName; }).map(function (x) {
            if (x.Entity1LogicalName === entity.LogicalName) {
                return x.Entity2LogicalName;
            }
            else {
                return x.Entity1LogicalName;
            }
        }).forEach(function (x) { return retValue.add(x); });
        return this.filterEntitiesToBeRetrieved(Array.from(retValue), entitiesToInclude, entitiesToExclude);
    };
    MetadataEntityPairTraversal.prototype.extractDisplayNames = function (entities, languageCode) {
        var _this = this;
        entities.forEach(function (entity) {
            if (_this.retrievedEntityDisplayNames[entity.LogicalName]) {
                return;
            }
            var displayName = extractDisplayNames(entity.DisplayName, languageCode, entity.LogicalName);
            _this.retrievedEntityDisplayNames[entity.LogicalName] = displayName;
        });
    };
    MetadataEntityPairTraversal.prototype.buildDisplayNamesFiter = function (primaryEntities) {
        var dividedEntities = this.divideEntitiesPerLimit(primaryEntities, this.DisplayNamesUrlLengthWithoutEntities);
        var retValue = dividedEntities.map(function (entities) {
            var filter = "$select=LogicalName,DisplayName";
            filter += "&$filter=";
            filter += "Microsoft.Dynamics.CRM.In(PropertyName='LogicalName',PropertyValues=[".concat(entities, "])");
            return filter;
        });
        return retValue;
    };
    MetadataEntityPairTraversal.prototype.buildEntityPairsFiter = function (primaryEntities, includeToOneRelationship, includeToManyRelationship) {
        var dividedEntities = this.divideEntitiesPerLimit(primaryEntities, this.EntityPairsUrlLengthWithoutEntities);
        var retValue = dividedEntities.map(function (entities) {
            var filter = "$select=LogicalName,DisplayName&$expand=";
            filter += includeToOneRelationship ? "Attributes($filter=AttributeType eq Microsoft.Dynamics.CRM.AttributeTypeCode'Lookup')," : "";
            filter += includeToManyRelationship ? "OneToManyRelationships($select=ReferencedEntity,ReferencingEntity)," : "";
            filter += includeToManyRelationship ? "ManyToManyRelationships($select=Entity1LogicalName,Entity2LogicalName)," : "";
            filter += includeToManyRelationship ? "ManyToOneRelationships($select=ReferencedEntity,ReferencingEntity)" : "";
            filter += "&$filter=";
            filter += "Microsoft.Dynamics.CRM.In(PropertyName='LogicalName',PropertyValues=[".concat(entities, "])");
            return filter;
        });
        return retValue;
    };
    MetadataEntityPairTraversal.prototype.divideEntitiesPerLimit = function (primaryEntities, urlLengthWithoutEntities) {
        var retValue = [];
        var entityLogicalNames = "";
        primaryEntities.forEach(function (entityName) {
            if (isMaxUrlLengthReached(entityLogicalNames.length, entityName.length, urlLengthWithoutEntities)) {
                retValue.push(removeCommaFromEnd(entityLogicalNames));
                entityLogicalNames = "'".concat(entityName, "',");
            }
            else {
                entityLogicalNames += "'".concat(entityName, "',");
            }
        });
        retValue.push(removeCommaFromEnd(entityLogicalNames));
        return retValue;
    };
    MetadataEntityPairTraversal.prototype.createEntityPair = function (logicalName, displayName) {
        return {
            logicalName: logicalName,
            displayName: displayName
        };
    };
    MetadataEntityPairTraversal.prototype.createEntityPairAsNode = function (logicalName, pathToNode) {
        return {
            logicalName: logicalName,
            pathToNode: { entities: pathToNode }
        };
    };
    MetadataEntityPairTraversal.prototype.createEntityPairWithNeighbours = function (entityLogicalName, neighbours) {
        return {
            entity: entityLogicalName,
            neighbours: neighbours
        };
    };
    return MetadataEntityPairTraversal;
}());
export { MetadataEntityPairTraversal };
